export const aircraft = [
  {
      "id": 21,
      "name": "Gulfstream G150",
      "tail_number": null,
      "status_id": 1,
      "is_part91": null,
      "is_part135": null,
      "manufacturer": "Gulfstream Aerospace",
      "model": "G150",
      "engine_type": "Twin turbofan",
      "engine_thrust_lb_ft": 4360,
      "max_speed_knots": 476,
      "cruise_speed_knots": 459,
      "ceiling_ft": 45000,
      "takeoff_ground_run_ft": 5100,
      "landing_ground_roll_ft": 2800,
      "gross_weight_lbs": 26250,
      "empty_weight_lbs": 16000,
      "length_ft": "56.800",
      "height_ft": "19.800",
      "wing_span_ft": "63.300",
      "range_nautical_miles": 3000,
      "color_hex": null,
      "seat_count": null,
      "created_by": 1,
      "modified_by": 1,
      "created_at": "2025-04-16T10:49:53.000000Z",
      "updated_at": "2025-04-16T10:49:53.000000Z"
  },
  {
      "id": 22,
      "name": "Gulfstream G550",
      "tail_number": null,
      "status_id": 1,
      "is_part91": null,
      "is_part135": null,
      "manufacturer": "Gulfstream Aerospace",
      "model": "G550",
      "engine_type": "Twin turbofan",
      "engine_thrust_lb_ft": 15285,
      "max_speed_knots": 488,
      "cruise_speed_knots": 459,
      "ceiling_ft": 51000,
      "takeoff_ground_run_ft": 5800,
      "landing_ground_roll_ft": 2770,
      "gross_weight_lbs": 91000,
      "empty_weight_lbs": 48500,
      "length_ft": "96.500",
      "height_ft": "25.800",
      "wing_span_ft": "93.500",
      "range_nautical_miles": 6750,
      "color_hex": null,
      "seat_count": null,
      "created_by": 1,
      "modified_by": 1,
      "created_at": "2025-04-16T10:49:53.000000Z",
      "updated_at": "2025-04-16T10:49:53.000000Z"
  },
  {
      "id": 23,
      "name": "Hawker 800XP",
      "tail_number": null,
      "status_id": 1,
      "is_part91": null,
      "is_part135": null,
      "manufacturer": "Hawker Beechcraft",
      "model": "800XP",
      "engine_type": "Twin turbofan",
      "engine_thrust_lb_ft": 4650,
      "max_speed_knots": 447,
      "cruise_speed_knots": 402,
      "ceiling_ft": 41000,
      "takeoff_ground_run_ft": 5030,
      "landing_ground_roll_ft": 2680,
      "gross_weight_lbs": 28000,
      "empty_weight_lbs": 16600,
      "length_ft": "51.200",
      "height_ft": "17.400",
      "wing_span_ft": "51.400",
      "range_nautical_miles": 2540,
      "color_hex": null,
      "seat_count": null,
      "created_by": 1,
      "modified_by": 1,
      "created_at": "2025-04-16T10:49:53.000000Z",
      "updated_at": "2025-04-16T10:49:53.000000Z"
  },
  {
      "id": 24,
      "name": "Learjet 60XR",
      "tail_number": null,
      "status_id": 1,
      "is_part91": null,
      "is_part135": null,
      "manufacturer": "Bombardier",
      "model": "60XR",
      "engine_type": "Twin turbofan",
      "engine_thrust_lb_ft": 4600,
      "max_speed_knots": 522,
      "cruise_speed_knots": 436,
      "ceiling_ft": 51000,
      "takeoff_ground_run_ft": 5400,
      "landing_ground_roll_ft": 3170,
      "gross_weight_lbs": 23500,
      "empty_weight_lbs": 14500,
      "length_ft": "58.600",
      "height_ft": "14.600",
      "wing_span_ft": "43.800",
      "range_nautical_miles": 2440,
      "color_hex": null,
      "seat_count": null,
      "created_by": 1,
      "modified_by": 1,
      "created_at": "2025-04-16T10:49:53.000000Z",
      "updated_at": "2025-04-16T10:49:53.000000Z"
  }
]